<template>
    <div>
        <div class="main">
            <ServerFilter
                :is-mounted="filterData.isMounted"
                :filter-data="filterData"
                @selectedFilters="sendFilters"
            />
            <vx-card v-if="false" class="text-center">
                <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
            </vx-card>
            <div v-else>
                <vs-row v-if="reports.cards.isMounted">
                    <vs-col v-for="(card, index) in reports.cards.data" :key="index"
                            class="sm:w-1/2 md:w-4/12 lg:w-3/12 xl:w-3/12">
                        <div class="pr-4 mb-4 ">
                            <DashboardCards
                                :data-card="card"
                            />
                        </div>
                    </vs-col>
                </vs-row>
                <div v-else class="text-center">
                    <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                </div>
                <div>
                    <vs-card class="shadow-none relative card" v-if="isAdv">
                        <div class="title">{{ $t('statistic.Traffic_by_advertiser') }}</div>
                        <div
                            v-if="reports.trafficByAdvertiser.isMounted"
                        >
                            <div v-if="reports.trafficByAdvertiser.tabs.length"
                                 :style="`height: ${getHeightWrapperBarChart(reports.trafficByAdvertiser.barChart.series[0].data.length)}`">
                                <vs-tabs
                                    v-model="reports.trafficByAdvertiser.selectedGeo"
                                    alignment="fixed"
                                >
                                    <vs-tab
                                        v-for="(item, index) of reports.trafficByAdvertiser.tabs"
                                        :key="index"
                                        :label="item"
                                        @click="trafficByAdvertiser(item)"
                                    >
                                        <VueApexCharts
                                            v-if="isLoad"
                                            ref="barChart"
                                            :options="reports.trafficByAdvertiser.barChart.chartOptions"
                                            :series="reports.trafficByAdvertiser.barChart.series"
                                            type="bar"
                                            :height="getHeightBarChart(reports.trafficByAdvertiser.barChart.series[0].data.length)"
                                        />
                                    </vs-tab>
                                </vs-tabs>
                            </div>
                            <no-data v-else/>
                        </div>
                        <div v-else class="text-center">
                            <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                        </div>
                    </vs-card>
                </div>

                <div>
                    <div class="ccard">
                        <div class="title">{{ $t('statistic.Statuses_Countries') }}</div>
                        <div v-if="reports.countryStatistic.isMounted">
                            <div class="mt-4" v-if="reports.countryStatistic.data.length">
                                <ds-table
                                    :data="reports.countryStatistic.data"
                                    :heads="reports.countryStatistic.headers"
                                    spacer
                                    :paginate-dropdown="false"
                                    :spacerGrey="true"
                                >
                                    <template v-slot:country="{country}">
                                        <div class="flex items-center">
                                            <flag width="25" type="country" :iso="country.country_code"/>
                                            <div class="ml-2">{{ country.country_name }}</div>
                                            <div class="ml-2">[{{ country.country_code }}]</div>
                                        </div>
                                    </template>
                                </ds-table>
                            </div>
                            <no-data v-else/>
                        </div>
                        <div v-else class="text-center">
                            <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="ccard">
                        <div class="title">{{ $t('statistic.CvStatistic') }}</div>
                        <div v-if="reports.cvStatistic.isMounted">
                            <div class="mt-4" v-if="reports.cvStatistic.data.length">
                                <ds-table
                                    :data="reports.cvStatistic.data"
                                    :heads="reports.cvStatistic.headers"
                                    expand
                                    :paginate-dropdown="false"
                                    :spacerGrey="true"
                                    search
                                    :search-keys="[
                                        'name',
                                    ]"
                                >
                                    <template v-slot:teams="{teams}">
                                        <div class="flex items-center">
                                            <vs-icon v-bind="$iconData('icon-users', 'fi-rr-users')"/>
                                            <div class="ml-2">{{teams.name}}</div>
                                        </div>
                                    </template>

                                    <template v-slot:expand="{expand}">
                                        <ds-table
                                            :data="expand.affiliates"
                                            :max-items="expand.affiliates.length"
                                            :heads="[
                                                {name: 'global.Affiliates', key: 'affiliate_name', sortKey: 'affiliate_name', value: 'affiliate_name', display: true, width: '280px'},
                                                {name: 'global.Leads', key: 'leads', sortKey: 'total', value: 'total', display: true},
                                                {name: 'global.Deposits', key: 'deposits', sortKey: 'deposits', value: 'deposits', display: true},
                                                {name: 'global.Conversion', key: 'conversion', sortKey: 'conversion', value: 'conversion', display: true},
                                            ]"
                                            spacer
                                            :paginate-dropdown="false"
                                            :spacerGrey="true"
                                            :paginate="false"
                                        ></ds-table>
                                    </template>
                                </ds-table>
                            </div>
                            <no-data v-else/>
                        </div>
                        <div v-else class="text-center">
                            <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                        </div>
                    </div>
                </div>

                <div>
                    <vs-card class="shadow-none relative card">
                        <div class="title">{{ $t('statistic.Hold_by_geo') }}</div>
                        <div v-if="reports.holdByGeos.isMounted">
                            <vs-tabs
                                v-if="reports.holdByGeos.listNamesGeo.length"
                                v-model="reports.holdByGeos.selectedGeo"
                                alignment="fixed"
                            >
                                <vs-tab
                                    v-for="(key, index) of reports.holdByGeos.listNamesGeo"
                                    @click="holdsByGeo(key)" :key="index"
                                    :id="index"
                                    class="p-0"
                                    :label="key"
                                >
                                    <template lang="html">
                                        <div class="mt-4">
                                            <ds-table
                                                :data="reports.holdByGeos.dataForSelectedGeo"
                                                :heads="[
                                                    {name: 'global.Affiliate', key: 'name', sortKey: 'name', value: 'name', display: true},
                                                    {name: 'global.Offer', key: 'offer_name', sortKey: 'offer_name', value: 'offer_name', display: true},
                                                    {name: 'global.Date', key: 'date', sortKey: 'created_at', value: 'date', display: true},
                                                    {name: 'global.Identifier', key: 'campaign_identifier', sortKey: 'campaign_identifier', value: 'campaign_identifier', display: true},
                                                    {name: 'global.Language', key: 'language', sortKey: 'language', value: 'language', display: true},
                                                    {name: 'global.Status', key: 'status', sortKey: 'status', value: 'status', display: true},
                                                ]"
                                                :max-items="10"
                                                :view-items="[10, 15, 20]"
                                                spacer
                                            >
                                                <template v-slot:date="{date}">
                                                    <div>{{ date.created_at | getDate }}, {{
                                                            date.created_at | getTime
                                                        }}
                                                    </div>
                                                </template>
                                            </ds-table>
                                        </div>
                                    </template>
                                </vs-tab>
                            </vs-tabs>
                            <no-data v-else/>
                        </div>
                        <div v-else class="text-center">
                            <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                        </div>
                    </vs-card>
                </div>

                <div>
                    <vs-card class="shadow-none relative card card_statistic">
                        <div class="title">{{ $t('statistic.Offer_domain_deps') }}</div>
                        <div v-if="reports.domainDepositsByOffers.isMounted">
                            <Table
                                v-if="reports.domainDepositsByOffers.data.length"
                                :tableData="reports.domainDepositsByOffers.data"
                                details
                            >
                                <template v-slot:head>
                                    <vs-th sort-key="name" class="column__name">{{ $t('global.Name') }}</vs-th>
                                    <vs-th sort-key="leads_total" class="column__data">{{ $t('global.Leads') }}</vs-th>
                                    <vs-th sort-key="deposits_total" class="column__data">{{
                                            $t('global.Deposits')
                                        }}
                                    </vs-th>
                                    <vs-th sort-key="conversion" class="column__data">%</vs-th>
                                </template>

                                <template v-slot:content="{content}">
                                    <vs-td>
                                        <p>{{ content.name }}</p>
                                    </vs-td>
                                    <vs-td>
                                        <p>{{ content.leads_total }}</p>
                                    </vs-td>
                                    <vs-td>
                                        <p>{{ content.deposits_total }}</p>
                                    </vs-td>
                                    <vs-td>
                                        <p>{{ Number(content.conversion).toFixed(2) }}</p>
                                    </vs-td>
                                </template>

                                <template v-slot:details="{details}">
                                    <DetailsDomainDepositsByOffers :detailsData="details.domains"
                                                                   :change-style-columns="true"/>
                                </template>
                            </Table>
                            <no-data v-else/>
                        </div>
                        <div v-else class="text-center">
                            <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                        </div>
                    </vs-card>
                </div>

                <div>
                    <vs-card class="shadow-none relative card card_statistic">
                        <div class="title">{{ $t('statistic.Statuses_Statistic') }}</div>
                        <div v-if="reports.statusesStatistics.isMounted">
                            <Table v-if="reports.statusesStatistics.data.length" :pagination="false" details
                                   :tableData="reports.statusesStatistics.data">
                                <template v-slot:head>
                                    <vs-th sort-key="name">{{ $t('global.Status') }}</vs-th>
                                    <vs-th sort-key="leads_total" class="column__leads">{{ $t('global.Leads') }}</vs-th>
                                    <vs-th sort-key="conversion" class="column__data">%</vs-th>
                                </template>

                                <template v-slot:content="{content}">
                                    <vs-td>
                                        <p class="product-name font-medium truncate">{{ content.name }}</p>
                                    </vs-td>
                                    <vs-td>
                                        <p class="product-name font-medium truncate">{{ content.leads_total }}</p>
                                    </vs-td>
                                    <vs-td>
                                        <p class="product-name font-medium truncate">
                                            {{ Number(content.conversion).toFixed(2) }}</p>
                                    </vs-td>
                                </template>

                                <template v-slot:details="{details}">
                                    <DetailStatusesStatisticDomain
                                        :detailsData="details.domains"
                                        :change-style-columns="true"
                                    />
                                </template>
                            </Table>
                            <no-data v-else/>
                        </div>
                        <div v-else class="text-center">
                            <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                        </div>
                    </vs-card>
                </div>

                <div v-if="isAdv">
                    <vs-card class="shadow-none relative card card_statistic">
                        <div class="title">{{ $t('statistic.advertiser_geoconversion') }}</div>
                        <div v-if="reports.advGeoConversionObj.isMounted">
                            <Table v-if="reports.advGeoConversionObj.data.length" :pagination="false" details
                                   :tableData="reports.advGeoConversionObj.data" stripe>
                                <template v-slot:head>
                                    <vs-th sort-key="name">{{ $t('global.Advertiser') }}</vs-th>
                                    <vs-th v-for="(item, index) of reports.advGeoConversionObj.heads" :key="index">
                                        {{ item }}
                                    </vs-th>
                                </template>

                                <template v-slot:content="{content}">
                                    <vs-td>
                                        <p class="product-name font-medium truncate">{{ content.name }}</p>
                                    </vs-td>
                                    <vs-td v-for="(conversion, ind) of content.conversion_by_geo" :key="ind">
                                        <div class="product-name font-medium truncate">
                                            {{ conversion[Object.keys(conversion)[0]] }}
                                        </div>
                                    </vs-td>
                                </template>
                            </Table>
                            <no-data v-else/>
                        </div>
                        <div v-else class="text-center">
                            <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                        </div>
                    </vs-card>
                </div>

                <div class="grid grid-cols-1 gap-x-4" :class="{ 'lg:grid-cols-2 xl:grid-cols-2': userState.group}">
                    <vs-card v-if="userState.group === 1" class="shadow-none relative card">
                        <div class="title">{{ $t('statistic.Top_5_affiliates') }}</div>
                        <div v-if="reports.isMountedTop5">
                            <VueApexCharts
                                ref="top5_AffiliatesByTraffic"
                                v-if="isLoad && reports.top5_AffiliatesByTraffic.series[0].data.length"
                                :options="reports.top5_AffiliatesByTraffic.chartOptions"
                                :series="reports.top5_AffiliatesByTraffic.series"
                                type="bar"
                                height="350"
                            />
                            <no-data v-else/>
                        </div>
                        <div v-else class="text-center">
                            <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                        </div>
                    </vs-card>

                    <vs-card v-else-if="userState.group === 2" class="shadow-none relative card">
                        <div class="title">{{ $t('statistic.Top_5_teams') }}</div>
                        <div v-if="reports.isMountedTop5 && isLoad">
                            <VueApexCharts
                                ref="top5_TeamsByTraffic"
                                v-if="reports.top5_TeamsByTraffic.series[0].data.length"
                                :options="reports.top5_TeamsByTraffic.chartOptions"
                                :series="reports.top5_TeamsByTraffic.series"
                                type="bar"
                                height="350"
                            />
                            <no-data v-else/>
                        </div>
                        <div v-else class="text-center">
                            <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                        </div>
                    </vs-card>

                    <vs-card class="shadow-none relative card">
                        <div class="title">{{ $t('statistic.Top_5_offers') }}</div>
                        <div v-if="reports.isMountedTop5 && isLoad">
                            <VueApexCharts
                                v-if="reports.top5_OffersByTraffic.series[0].data.length"
                                :options="reports.top5_OffersByTraffic.chartOptions"
                                :series="reports.top5_OffersByTraffic.series"
                                type="bar"
                                height="350"
                            />
                            <no-data v-else/>
                        </div>
                        <div v-else class="text-center">
                            <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                        </div>
                    </vs-card>
                </div>

                <div v-if="isAdv">
                    <vs-card class="shadow-none relative card">
                        <div class="title">{{ $t('statistic.Deposits_by_advertiser') }}</div>
                        <div
                            v-if="reports.depositsByAdvertiser.isMounted"
                        >
                            <div
                                v-if="reports.depositsByAdvertiser.tabs.length"
                                :style="`height: ${getHeightWrapperBarChart(reports.depositsByAdvertiser.barChart.series[0].data.length)}`"
                            >
                                <vs-tabs alignment="fixed"
                                         v-model="reports.depositsByAdvertiser.selectedTab">
                                    <vs-tab v-for="(item, index) of reports.depositsByAdvertiser.tabs" :key="index"
                                            :label="item" @click="advertiserDepositsTab(item)">
                                        <VueApexCharts
                                            v-if="isLoad"
                                            :options="reports.depositsByAdvertiser.barChart.chartOptions"
                                            :series="reports.depositsByAdvertiser.barChart.series"
                                            type="bar"
                                            :height="getHeightBarChart(reports.depositsByAdvertiser.barChart.series[0].data.length)"
                                        />
                                    </vs-tab>
                                </vs-tabs>
                            </div>
                            <no-data v-else/>
                        </div>
                        <div v-else class="text-center">
                            <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                        </div>
                    </vs-card>
                </div>

                <div>
                    <div class="grid grid-cols-1 gap-x-4  lg:grid-cols-2 xl:grid-cols-2">
                        <vs-card class="shadow-none">
                            <div class="title">{{ $t('statistic.Deposits_by_user_team') }}</div>
                            <div v-if="reports.depositsByTeams.isMounted">
                                <e-charts
                                    v-if="reports.depositsByTeams.chart.series[0].data.length"
                                    :options="reports.depositsByTeams.chart"
                                    autoresize
                                />
                                <no-data v-else/>
                            </div>
                            <div v-else class="text-center">
                                <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                            </div>
                        </vs-card>
                        <vs-card class="shadow-none">
                            <div class="title">{{ $t('statistic.Deposits_by_offer') }}</div>
                            <div v-if="reports.depositsByOffers.isMounted">
                                <e-charts
                                    v-if="reports.depositsByOffers.chart.series[0].data.length"
                                    :options="reports.depositsByOffers.chart"
                                    autoresize
                                />
                                <no-data v-else/>
                            </div>
                            <div v-else class="text-center">
                                <c-loader color="rgba(var(--vs-primary),1)"></c-loader>
                            </div>
                        </vs-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

import VueApexCharts from 'vue-apexcharts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/pie'
import ECharts from 'vue-echarts/components/ECharts'

import ServerFilter from '../../../components/filters/ServerFilter'
import FieldFilter from '@/components/filters/Filter'
import DatePicker from '@/components/date-picker/Picker'

import DashboardCards from './DashboardCards'
import Table from '@/components/custom-table/Table'
import DetailsDomainDepositsByOffers from './DetailsDomainDepositsByOffers'
import DetailStatusesStatisticDomain from './DetailStatusesStatisticDomain'

import {createDate} from '@/utils/utils'
import send from '@/utils/fetch'
import ErrorHandler from '../../../utils/errorHandler'
import {Charts} from '@/classes/Chart.js'
import {getDate, checkPermission, flag} from '@/utils/mixins'

export default {
    components: {
        VueApexCharts,
        ECharts,
        ServerFilter,
        FieldFilter,
        DatePicker,
        DashboardCards,
        DetailsDomainDepositsByOffers,
        Table,
        DetailStatusesStatisticDomain
    },
    mixins: [getDate, flag, checkPermission],

    data() {
        return {
            lang: 'en',
            reports: {
                cards: {
                    isMounted: false,
                    data: []
                },
                advGeoConversionObj: {
                    isMounted: false,
                    data: [],
                    heads: []
                },
                holdByGeos: {
                    isMounted: false,
                    selectedGeo: 0,
                    listNamesGeo: [],
                    allData: [],
                    dataForSelectedGeo: []
                },
                trafficByAdvertiser: {
                    isMounted: false,
                    activeTab: 'RU',
                    selectedGeo: 0,
                    data: [],
                    tabs: [],
                    barChart: Charts.barChart()
                },
                countryStatistic: {
                    isMounted: false,
                    data: [],
                    headers: [
                        {
                            name: 'global.Country',
                            key: 'country',
                            sortKey: 'country_name',
                            value: 'country',
                            display: true
                        },
                        {name: 'global.Leads', key: 'leads', sortKey: 'total', value: 'total', display: true},
                        {name: 'global.Deposits', key: 'deposits', sortKey: 'deposits', value: 'deposits', display: true},
                        {name: 'global.Conversion', key: 'conversion', sortKey: 'conversion', value: 'conversion', display: true},
                    ],
                    meta: {},
                    limit: 10
                },
                cvStatistic: {
                    isMounted: false,
                    data: [],
                    headers: [
                        {name: 'global.Teams', key: 'name', sortKey: 'name', value: 'teams', display: true, width: '250px'},
                        {name: 'global.Leads', key: 'leads', sortKey: 'total', value: 'total', display: true},
                        {name: 'global.Deposits', key: 'deposits', sortKey: 'deposits', value: 'deposits', display: true},
                        {name: 'global.Conversion', key: 'conversion', sortKey: 'conversion', value: 'conversion', display: true},
                    ],
                    meta: {},
                    limit: 10
                },
                domainDepositsByOffers: {
                    isMounted: false,
                    data: []
                },
                statusesStatistics: {
                    isMounted: false,
                    data: []
                },
                depositsByAdvertiser: {
                    isMounted: false,
                    selectedTab: 0,
                    data: [],
                    tabs: [],
                    barChart: Charts.barChart()
                },
                isMountedTop5: false,
                top5_AffiliatesByTraffic: Charts.barChart(),
                top5_OffersByTraffic: Charts.barChart(),
                top5_TeamsByTraffic: Charts.barChart(),
                depositsByTeams: {
                    isMounted: false,
                    chart: Charts.pieChart()
                },
                depositsByOffers: {
                    isMounted: false,
                    chart: Charts.pieChart()
                }
            },
            filterData: {
                defaultDate: {
                    startDate: new Date(),
                    endDate: new Date(),
                },
                date: {
                    created_at: {
                        label: 'global.Registration_date',
                        startDate: new Date(),
                        endDate: new Date(),
                        direction: 'created_at'
                    },
                    send_date: {
                        label: 'global.Send_date',
                        startDate: new Date(),
                        endDate: new Date(),
                        direction: 'send_date'
                    }
                },
                fieldsWithDependencies: {
                    advertisers: 'integrations',
                    teams: 'affiliates'
                },
                isMounted: false,
                allFiltersByDate: {},
                filtersBasedOnFilters: {}
            },
            isLoad: true
        }
    },

    computed: {
        ...mapGetters(['userState']),
        isAdv() {
            return this.userState.group === 2 || this.userState.team.is_internal || this.isPermission('statistic_lead.advertiser')
        }
    },

    watch: {
        async '$i18n.locale'(v) {
            this.isLoad = false
            this.lang = v

            this.advertiserDepositsTab()
            this.trafficByAdvertiser()
            this.reports.top5_TeamsByTraffic.chartOptions.chart.defaultLocale = v
            this.reports.top5_OffersByTraffic.chartOptions.chart.defaultLocale = v
            this.reports.top5_AffiliatesByTraffic.chartOptions.chart.defaultLocale = v
            setTimeout(() => {
                this.isLoad = true
            }, 100)
        }
    },

    methods: {
        sendFilters(data) {
            const filters = data.fields && Object.keys(data.fields).length ? data.fields : null
            const date = data.date.selectedDirection ? data.date[data.date.selectedDirection] : data.date.created_at
            this.send(date, filters)
        },

        advertiserDepositsTab(name) {
            if (!this.reports.depositsByAdvertiser.data.length) {
                return
            }

            if (!name) {
                name = this.reports.depositsByAdvertiser.data[0].geos
            }

            const result = this.reports.depositsByAdvertiser.data.filter(el => el.geos === name)

            const data = result.map(el => el.value)
            const names = result.map(el => el.name)

            this.reports.depositsByAdvertiser.barChart = Charts.barChart(data, names, this.lang)
        },

        holdsByGeo(name) {
            if (!name) {
                name = this.reports.holdByGeos.listNamesGeo[this.reports.holdByGeos.selectedGeo]
            }
            this.reports.holdByGeos.dataForSelectedGeo = this.reports.holdByGeos.allData[name]
        },

        trafficByAdvertiser(name) {
            if (!this.reports.trafficByAdvertiser.data.length) {
                return
            }

            if (!name) {
                name = this.reports.trafficByAdvertiser.data.length ? this.reports.trafficByAdvertiser.data[0].geos : this.reports.trafficByAdvertiser.activeTab
            }

            const result = this.reports.trafficByAdvertiser.data.filter(el => el.geos === name)


            const data = result.map(el => el.count)
            const names = result.map(el => el.advertiser_name)

            this.reports.trafficByAdvertiser.barChart = Charts.barChart(data, names, this.lang)
            this.reports.trafficByAdvertiser.activeTab = name
            // this.reports.trafficByAdvertiser.barChart.chartOptions.chart.defaultLocale = this.lang
        },

        setListNamesGeo(data) {
            const arrayHoldsData = []
            for (const geoKey in data) {
                arrayHoldsData.push(geoKey)
            }
            this.reports.holdByGeos.listNamesGeo = arrayHoldsData
        },

        async send(date, filters) {
            const dep = {
                integrations: "advertisers",
                affiliates: "teams"
            }

            let params = {
                direction: date.direction,
                start: createDate(date.startDate),
                end: createDate(date.endDate)
            }

            let names = {}
            let ids = {}

            if (filters) {
                const {allFiltersByDate} = this.filterData

                Object.entries(filters).forEach(([key, value]) => {
                    value.forEach(item => {
                        if (!ids[key]) ids[key] = []
                        if (!names[key]) names[key] = []

                        if (typeof item === 'number') {
                            ids[key].push(item)

                            if (!allFiltersByDate[key]) {
                                allFiltersByDate[dep[key]].map(a => {
                                    a[key].map(elem => {
                                        if (elem.id === item) names[key].push(elem.name)
                                    })
                                })
                            } else {
                                allFiltersByDate[key].map(a => {
                                    if (a.id === item) names[key].push(a.name)
                                })
                            }
                        } else {
                            names[key].push(item)

                            if (allFiltersByDate[key]) {
                                const elem = allFiltersByDate[key].find(a => (a.name || a) === item)

                                if (elem) {
                                    if (typeof elem === 'string') {
                                        ids[key].push(elem)
                                    } else {
                                        ids[key].push(elem.id)
                                    }
                                } else {
                                    allFiltersByDate[dep[key]].map(a => {
                                        a[key].map(elem => {
                                            if (elem.name === item) ids[key].push(elem.id)
                                        })
                                    })
                                }
                            }
                        }
                    })
                })
            }

            const data = {
                ...params,
                ...names,
                advertisers: ids.advertisers,
                teams: ids.teams
            }

            const _data = JSON.parse(JSON.stringify(data))

            if (_data.integrations && Array.isArray(_data.integrations) && _data.integrations.length) {
                _data.integrations_id = ids.integrations

                delete _data.integrations
            }

            try {
                await this.initReportGeoHolds({...data})

                this.initReportDashboardCards({...params, ...ids})

                if (this.isAdv) {
                    this.initReportTrafficByAdvertiser({...data})
                    this.advGeoConversion({...data})
                }

                this.countryStatistic({..._data}, filters)
                this.cvStatistic({..._data})
                this.initReportDomainDepositsByOffers({...data})
                this.initReportStatusesStatistics({...data})
                this.initReportsTop5({...data})
                this.initReportDepositsByAdvertiser({...data})
                this.initReportDepositsByOffers({...data})
                this.initReportDepositsByTeams({...data})

                this.initFilters({...data}, filters)
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        countryStatistic(params, filters) {
            this.reports.countryStatistic.isMounted = false

            const template = {
                integrations: 'integrations_id'
            }

            const formattedParams = Object.entries(params).reduce((result, [key, value]) => {
                result[template[key] || key] = template[key] ? filters[key] : value
                return result;
            }, {});

            send(this.$url.statistic.main.countries, 'GET', {params: formattedParams})
                .then(response => response.data.result)
                .then(response => {
                    this.reports.countryStatistic.data = response.data.map(item => {
                        item.conversion = (item.deposits / item.total * 100).toFixed(2)
                        return item
                    })
                    this.reports.countryStatistic.isMounted = true
                })
                .catch(e => new ErrorHandler(e).send)
        },

        cvStatistic(params) {
            this.reports.cvStatistic.isMounted = false
            send(this.$url.statistic.main.affiliates, 'POST', {data: params}, false)
                .then(response => response.data.result.teams)
                .then(response => {
                    this.reports.cvStatistic.data = response.reduce((res, item) => {
                        const counts = {
                            total: 0,
                            deposits: 0,
                            conversion: 0,
                        }

                        item.affiliates.map(aff =>
                            Object.keys(counts).map(key => counts[key] += aff[key])
                        )

                        res.push({
                            ...item,
                            ...counts
                        })

                        return res.map(item => {
                            item.conversion = (+item.deposits / +item.total * 100).toFixed(2)
                            return item
                        })
                    }, [])

                    this.reports.cvStatistic.isMounted = true
                    return response
                })
                .catch(e => new ErrorHandler(e).send)
        },

        advGeoConversion(params) {
            this.reports.advGeoConversionObj.isMounted = false
            send(this.$url.statistic.main['adv-geo-conversion'], 'POST', {data: params}, false)
                .then(response => response.data.geo_conversion_by_advertiser)
                .then(response => {
                    let head = []
                    this.reports.advGeoConversionObj.heads = response.map(item => {
                        item.conversion_by_geo.map(list => head.push(...Object.keys(list)))
                    })
                    this.reports.advGeoConversionObj.heads = [...new Set(head)]
                    this.reports.advGeoConversionObj.data = response
                    this.reports.advGeoConversionObj.isMounted = true
                })
                .catch(e => {
                    new ErrorHandler(e).send
                })
        },

        async initReportGeoHolds(params) {
            this.reports.holdByGeos.isMounted = false
            try {
                await send(this.$url.statistic.main.geo_holds, 'POST', {data: params}, false).then(response => {
                    this.setListNamesGeo(response.data.geo_holds.data)
                    this.reports.holdByGeos.allData = response.data.geo_holds.data
                    this.reports.holdByGeos.selectedGeo = 0
                    this.holdsByGeo()
                    this.reports.holdByGeos.isMounted = true

                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        initReportDashboardCards(params) {
            this.reports.cards.isMounted = false
            try {
                send(this.$url.statistic.main.dashboard_cards, 'POST', {data: params}, false).then(response => {
                    this.reports.cards.data = response.data
                    this.reports.cards.isMounted = true
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        initReportTrafficByAdvertiser(params) {
            this.reports.trafficByAdvertiser.isMounted = false
            try {
                send(this.$url.statistic.main.traffic_by_advertiser, 'POST', {data: params}, false).then(response => {
                    this.reports.trafficByAdvertiser.tabs = response.data.traffic_by_advertiser.tabs
                    this.reports.trafficByAdvertiser.data = response.data.traffic_by_advertiser.data

                    this.reports.trafficByAdvertiser.data = this.reports.trafficByAdvertiser.data.map(item => {
                        item.advertiser_name = item.advertiser_name.toString()

                        return item
                    })

                    this.trafficByAdvertiser()
                    this.reports.trafficByAdvertiser.selectedGeo = 0
                    this.reports.trafficByAdvertiser.isMounted = true
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        initReportDomainDepositsByOffers(params) {
            this.reports.domainDepositsByOffers.isMounted = false
            try {
                send(this.$url.statistic.main.offer_domain_adv_deps, 'POST', {data: params}, false).then(response => {
                    this.reports.domainDepositsByOffers.data = response.data.offer_domain_adv_deps
                    this.reports.domainDepositsByOffers.isMounted = true
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        initReportStatusesStatistics(params) {
            this.reports.statusesStatistics.isMounted = false
            try {
                send(this.$url.statistic.main.statuses_domain_adv_deps, 'POST', {data: params}, false).then(response => {
                    this.reports.statusesStatistics.data = response.data.statuses_domain_adv
                    this.reports.statusesStatistics.isMounted = true
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        initReportsTop5(params) {
            this.reports.isMountedTop5 = false
            try {
                send(this.$url.statistic.main.top5_traffic, 'POST', {data: params}, false).then(response => {
                    const data = Object.fromEntries(
                        Object.entries(response.data).map(([key, value]) => [key,
                            {...value, labels: value.labels.map(item => item.toString())},
                        ])
                    )

                    if (this.userState.group === 1) {
                        this.reports.top5_AffiliatesByTraffic = Charts.barChart(data.top_5_affiliates.data, data.top_5_affiliates.labels, this.$i18n.locale)
                    } else if (this.userState.group === 2) {
                        this.reports.top5_TeamsByTraffic = Charts.barChart(data.top_5_teams.data, data.top_5_teams.labels, this.$i18n.locale)
                    }

                    this.reports.top5_OffersByTraffic = Charts.barChart(data.top_5_offers.data, data.top_5_offers.labels, this.$i18n.locale)

                    this.reports.isMountedTop5 = true
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        initReportDepositsByAdvertiser(params) {
            this.reports.depositsByAdvertiser.isMounted = false
            try {
                send(this.$url.statistic.main.advertiser_deps, 'POST', {data: params}, false).then(response => {
                    if (this.isAdv) {
                        this.reports.depositsByAdvertiser.tabs = response.data.advertiser_deps.tabs
                        this.reports.depositsByAdvertiser.data = response.data.advertiser_deps.data

                        this.reports.depositsByAdvertiser.data = this.reports.depositsByAdvertiser.data.map(item => {
                            item.name = String(item.name)

                            return item
                        })
                    }
                    this.advertiserDepositsTab()
                    this.reports.depositsByAdvertiser.selectedTab = 0
                    this.reports.depositsByAdvertiser.isMounted = true
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        initReportDepositsByTeams(params) {
            this.reports.depositsByTeams.isMounted = false
            try {
                send(this.$url.statistic.main.team_deps, 'POST', {data: params}, false).then(response => {
                    this.reports.depositsByTeams.chart = Charts.pieChart(response.data.team_deps.data, this.lang)
                    this.reports.depositsByTeams.isMounted = true
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        initReportDepositsByOffers(params) {
            this.reports.depositsByOffers.isMounted = false
            try {
                send(this.$url.statistic.main.offer_deps, 'POST', {data: params}, false).then(response => {
                    this.reports.depositsByOffers.chart = Charts.pieChart(response.data.offer_deps.data, this.lang)
                    this.reports.depositsByOffers.isMounted = true
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        initFilters(params, requestWithFilters) {
            this.filterData.isMounted = false
            try {
                send(this.$url.statistic.main.filters, 'POST', {data: params}, false).then(response => {
                    const filters = {...response.data.filters}

                    //MUTATION
                    const mutation = obj => Object.keys(obj).map(key => ({id: ~~key, name: obj[key]}))

                    //remove null
                    filters.domains = filters.domains.filter(item => item)
                    //remove null end

                    filters.traffic_models = mutation(filters.traffic_models)
                    filters.offers = mutation(filters.offers)
                    filters.affiliates = mutation(filters.affiliates)

                    filters.advertisers.map(advertiser => advertiser.integrations = mutation(advertiser.integrations))
                    filters.teams.map(team => team.affiliates = mutation(team.affiliates))
                    //MUTATION

                    if (this.userState && this.userState.team) {
                        if (this.userState.group === 2) {
                            delete filters.affiliates
                        } else if (this.userState.group === 1) {
                            delete filters.teams
                            if (!this.isAdv) {
                                delete filters.advertisers
                            }
                        } else if (this.userState.group === 0) {
                            delete filters.teams
                            delete filters.affiliates
                            if (!this.isAdv) {
                                delete filters.advertisers
                            }
                        }
                    }

                    if (requestWithFilters) {
                        this.$set(this.filterData, 'filtersBasedOnFilters', filters)
                    } else {
                        this.$set(this.filterData, 'filtersBasedOnFilters', {})
                        this.$set(this.filterData, 'allFiltersByDate', filters)
                    }

                    this.filterData.isMounted = true
                })
            } catch (e) {
                new ErrorHandler(e).send
            }

        },

        getHeightWrapperBarChart(length) {
            const addedWidthForCorrectPadding = 50
            return length ? `${this.getHeightBarChart(length) + addedWidthForCorrectPadding}px` : 'auto'
        },

        getHeightBarChart(length) {
            const minHeight = 200,
                minimumCountsBars = 4,
                heightForOneBar = 40
            return length > minimumCountsBars ? length * heightForOneBar : minHeight
        }
    },

    async mounted() {
        try {
            await this.send(this.filterData.date.created_at)
        } catch (e) {
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss">
.main {
    .dsTable__content {
        tr {
            div {
                font-size: 1rem !important;
            }
        }
    }

    .ccard {
        background-color: white;
        padding: 10px;
        width: 100%;
        height: auto;
        border-radius: 8px;
        margin-bottom: 20px;
    }

    .card_statistic {
        .vs-con-table {
            .vs-table {
                border-collapse: collapse;
                padding: 0 1rem;

                thead {
                    .column__name {
                        width: 35%;
                    }

                    .column__leads {
                        width: 40%;
                    }

                    .column__data {
                        width: 20%;
                    }
                }

                tr {
                    &.spacer {
                        background: none;
                        box-shadow: none;

                        & td {
                            padding: 5px;
                        }
                    }

                    td {
                        /*padding: 20px;*/
                        &:first-child {
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;

                            &.td-check {
                                max-width: 30px;
                                padding: 20px 0 20px 15px !important;
                            }
                        }

                        &:last-child {
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }

                        .vs-button.small {
                            padding: 0.5rem 1rem;

                            &.includeIcon {
                                padding: 0.5rem 1rem 0.5rem 0.7rem;
                            }
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }

                    &.tr-expandedx {
                        td {
                            &:first-child {
                                border-bottom-left-radius: 0;
                            }

                            &:last-child {
                                border-bottom-right-radius: 0;
                            }
                        }
                    }

                    &.tr-expand {
                        border-top: 1px solid #ececec;

                        td {
                            padding: 5px;

                            &:first-child {
                                border-top-left-radius: 0;
                            }

                            &:last-child {
                                border-top-right-radius: 0;
                            }

                            .content-tr-expand {
                                padding: 0;
                                border: none;
                            }
                        }

                        .table__column_size {
                            .column__domain {
                                width: 36%;
                            }

                            .column__data {
                                width: 20%;
                            }

                            .cell__data {
                                padding: 10px 15px !important;
                            }

                            .column__advertiser {
                                width: 40%;
                            }
                        }
                    }
                }
            }

        }
    }

    .title {
        font-style: normal;
        font-weight: normal;
        font-size: 19px;
        line-height: 17px;
        padding: 20px;
        color: #000000;
        border-bottom: 1px solid #E2E2E2;
    }

    .header {
        border-bottom: 1px solid #E2E2E2;
        padding: 20px;

        &__count {
            font-style: normal;
            font-weight: bold;
            font-size: 24px;
        }

        &__global {
            background: #EAE8FD;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

</style>
